var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            "close-on-click-modal": false,
            visible: _vm.innerVisible,
            title: _vm.$t("CargoMsg.Cargo_SplitExpense"),
            "show-close": false,
            width: "400px"
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            },
            close: _vm.cancel
          }
        },
        [
          _c(
            "div",
            { staticClass: "app-main-inner-row" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    "label-position": "left",
                    "label-width": "70px",
                    model: _vm.charge
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Billing.billingJob_businessNumber")
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { disabled: true, no: "1" },
                        model: {
                          value: _vm.charge.jobJobNo,
                          callback: function($$v) {
                            _vm.$set(_vm.charge, "jobJobNo", $$v)
                          },
                          expression: "charge.jobJobNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("Billing.billingJob_chargeItem") }
                    },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "165px" },
                        attrs: {
                          "select-type":
                            _vm.selectTypeNames.basic_data_ChargeItem,
                          no: "2",
                          filterable: "",
                          "default-value": _vm.charge.chargeChargeItemId,
                          disabled: true
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("Billing.billingCharge_currency") }
                    },
                    [
                      _c("el-input", {
                        attrs: { disabled: true, no: "3" },
                        model: {
                          value: _vm.charge.chargeCurrency,
                          callback: function($$v) {
                            _vm.$set(_vm.charge, "chargeCurrency", $$v)
                          },
                          expression: "charge.chargeCurrency"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Billing.billingCharge_taxIncludedPrice")
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { disabled: true, no: "4" },
                        model: {
                          value: _vm.charge.chargeAmount,
                          callback: function($$v) {
                            _vm.$set(_vm.charge, "chargeAmount", $$v)
                          },
                          expression: "charge.chargeAmount"
                        }
                      })
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c(
                      "span",
                      { staticStyle: { width: "235px", color: "red" } },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_PETSFIIB")))]
                    )
                  ]),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Billing.billingCharge_taxIncludedPrice")
                      }
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "165px" },
                        attrs: { no: "5", controls: false },
                        model: {
                          value: _vm.amount,
                          callback: function($$v) {
                            _vm.amount = $$v
                          },
                          expression: "amount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("Billing.billingJob_chargeItem") }
                    },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "165px" },
                        attrs: {
                          "select-type":
                            _vm.selectTypeNames.basic_data_ChargeItem,
                          no: "6",
                          filterable: "",
                          "default-value": _vm.chargeItemId
                        },
                        on: {
                          parentCallBack: function(item) {
                            return (this$1.chargeItemId = item.itemId)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Billing.billingJob_settlementCompany")
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "165px" },
                        attrs: {
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          no: "7",
                          "default-value": _vm.accountId
                        },
                        on: {
                          parentCallBack: function(item) {
                            return (this$1.accountId = item.cmpIdx)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "8", size: "mini" },
                  on: { click: _vm.successEvent }
                },
                [_vm._v(_vm._s(_vm.$t("Billing.billingView_Determine")))]
              ),
              _c(
                "el-button",
                { attrs: { size: "mini", no: "9" }, on: { click: _vm.cancel } },
                [_vm._v(_vm._s(_vm.$t("Billing.billingView_Close")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }